{
  "v": "5.9.4",
  "fr": 24,
  "ip": 0,
  "op": 72,
  "w": 500,
  "h": 500,
  "nm": "Ziro-Reset_Voicemail_Icon",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Arrows",
      "parent": 2,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": {
          "a": 1,
          "k": [
            { "i": { "x": [0.281], "y": [1] }, "o": { "x": [0.654], "y": [0] }, "t": 9, "s": [0] },
            { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.219], "y": [0] }, "t": 25, "s": [365] },
            { "i": { "x": [0.652], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 35, "s": [357] },
            { "t": 46, "s": [360] }
          ],
          "ix": 10
        },
        "p": { "a": 0, "k": [-0.05, -0.05, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [268.05, 262.75, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [3.2, 0],
                    [1.2, 2.4],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-3.1, 0],
                    [-0.9, 3.8],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-0.8, 3.1],
                    [-2.8, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [1.5, 2.6],
                    [4, 0],
                    [0, 0],
                    [0, 0.1]
                  ],
                  "v": [
                    [7.15, -3.35],
                    [7.05, -3.15],
                    [0.25, 2.15],
                    [-6.15, -1.85],
                    [-3.75, -1.85],
                    [-3.75, -3.25],
                    [-8.65, -3.25],
                    [-8.65, 1.45],
                    [-7.15, 1.45],
                    [-7.15, -0.75],
                    [0.25, 3.45],
                    [8.55, -3.15],
                    [8.65, -3.45]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.043137256056, 0.145098045468, 0.152941182256, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [268.05, 267.55], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [-3.2, 0],
                    [-1.2, -2.4],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [3.1, 0],
                    [0.9, -3.8],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0.8, -3.1],
                    [2.8, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.5, -2.6],
                    [-3.9, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-7.05, 3.25],
                    [-0.25, -2.05],
                    [6.15, 1.95],
                    [3.75, 1.95],
                    [3.75, 3.35],
                    [8.65, 3.35],
                    [8.65, -1.45],
                    [7.15, -1.45],
                    [7.15, 0.75],
                    [-0.25, -3.45],
                    [-8.55, 3.15],
                    [-8.65, 3.45],
                    [-7.15, 3.45]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.043137256056, 0.145098045468, 0.152941182256, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [268.05, 257.95], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 72,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Circle",
      "parent": 3,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [259.29, 254.82, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [-8.06, -8.28, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.304, 0.304, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.413, 0.413, 0.333], "y": [0, 0, 0] },
              "t": 4,
              "s": [100, 100, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.606, 0.606, 0.333], "y": [0, 0, 0] },
              "t": 12,
              "s": [110, 110, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.209, 0.209, 0.333], "y": [0, 0, 0] },
              "t": 23,
              "s": [96, 96, 100]
            },
            {
              "i": { "x": [0.419, 0.419, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 34,
              "s": [103, 103, 100]
            },
            { "t": 46, "s": [100, 100, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-8.174, 0],
                    [0, -8.174],
                    [8.174, 0],
                    [0, 8.174]
                  ],
                  "o": [
                    [8.174, 0],
                    [0, 8.174],
                    [-8.174, 0],
                    [0, -8.174]
                  ],
                  "v": [
                    [0, -14.8],
                    [14.8, 0],
                    [0, 14.8],
                    [-14.8, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 72,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "Mail",
      "parent": 4,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [0, -2, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [249.05, 246.2, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.304, 0.304, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.413, 0.413, 0.333], "y": [0, 0, 0] },
              "t": 1,
              "s": [100, 100, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.606, 0.606, 0.333], "y": [0, 0, 0] },
              "t": 7,
              "s": [110, 110, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.209, 0.209, 0.333], "y": [0, 0, 0] },
              "t": 17,
              "s": [96, 96, 100]
            },
            {
              "i": { "x": [0.419, 0.419, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 27,
              "s": [102, 102, 100]
            },
            { "t": 37, "s": [100, 100, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [0.05, 0.5],
                    [-20.75, -15.4],
                    [20.75, -15.4]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.2, 0],
                    [-0.2, 0.1],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0.2, 0.2],
                    [0.3, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [-23.15, 15.4],
                    [-23.15, -14.1],
                    [-0.75, 3],
                    [-0.05, 3.2],
                    [0.65, 3],
                    [23.05, -14.1],
                    [23.05, 15.4],
                    [-23.15, 15.4]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 2,
              "ty": "sh",
              "ix": 3,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0.1, 0.1],
                    [0, 0],
                    [0.1, 0],
                    [0.1, 0],
                    [0, 0],
                    [0, 0.1],
                    [0, 0.1],
                    [0.1, 0],
                    [0, 0],
                    [0.1, -0.1],
                    [0, -0.1],
                    [0, -0.1],
                    [0, 0],
                    [0.1, 0],
                    [0.1, 0],
                    [0, 0],
                    [0, -0.1],
                    [0, 0],
                    [0, 0],
                    [-0.7, 0],
                    [0, 0],
                    [0, 0.7],
                    [0, 0]
                  ],
                  "o": [
                    [0, -0.1],
                    [0, 0],
                    [0, 0],
                    [0, -0.1],
                    [0, 0],
                    [-0.1, -0.1],
                    [0, 0],
                    [-0.1, -0.1],
                    [0, 0],
                    [-0.2, 0],
                    [0, 0],
                    [-0.1, 0],
                    [0, 0],
                    [-0.1, 0.1],
                    [0, 0],
                    [0, 0],
                    [0, 0.1],
                    [0, 0],
                    [0, 0],
                    [0, 0.7],
                    [0, 0],
                    [0.7, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [25.55, -16.6],
                    [25.45, -17],
                    [25.45, -17],
                    [25.35, -17.1],
                    [25.15, -17.3],
                    [25.05, -17.4],
                    [24.85, -17.6],
                    [24.75, -17.7],
                    [24.35, -17.8],
                    [-24.35, -17.8],
                    [-24.75, -17.7],
                    [-24.85, -17.6],
                    [-25.05, -17.4],
                    [-25.15, -17.3],
                    [-25.35, -17.1],
                    [-25.45, -17],
                    [-25.45, -17],
                    [-25.55, -16.6],
                    [-25.55, -16.6],
                    [-25.55, 16.6],
                    [-24.35, 17.8],
                    [24.35, 17.8],
                    [25.55, 16.6],
                    [25.55, -16.6]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 3",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [249.05, 246.2], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0.1, 0.2],
                    [0, 0],
                    [0.1, 0],
                    [0.1, 0],
                    [0, 0],
                    [0.1, 0.1],
                    [0, 0.1],
                    [0.1, 0],
                    [0, 0],
                    [0.1, -0.1],
                    [0, -0.1],
                    [0, -0.1],
                    [0, 0],
                    [0.1, -0.1],
                    [0.1, 0],
                    [0, 0],
                    [0, -0.2],
                    [0, 0],
                    [0, 0],
                    [-0.6, 0],
                    [0, 0],
                    [0, 0.6],
                    [0, 0]
                  ],
                  "o": [
                    [0, -0.1],
                    [0, 0],
                    [0, 0],
                    [0, -0.1],
                    [0, 0],
                    [-0.1, -0.1],
                    [0, 0],
                    [-0.1, 0],
                    [0, 0],
                    [-0.1, 0],
                    [0, 0],
                    [-0.1, 0],
                    [0, 0],
                    [-0.1, 0.1],
                    [0, 0],
                    [0, 0],
                    [0, 0.1],
                    [0, 0],
                    [0, 0],
                    [0, 0.6],
                    [0, 0],
                    [0.6, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [24.15, -15.6],
                    [24.05, -16],
                    [24.05, -16],
                    [23.95, -16.1],
                    [23.75, -16.3],
                    [23.65, -16.4],
                    [23.45, -16.6],
                    [23.35, -16.7],
                    [22.95, -16.8],
                    [-22.95, -16.8],
                    [-23.35, -16.7],
                    [-23.45, -16.6],
                    [-23.65, -16.4],
                    [-23.75, -16.3],
                    [-23.95, -16.1],
                    [-24.05, -16],
                    [-24.05, -16],
                    [-24.15, -15.6],
                    [-24.15, -15.6],
                    [-24.15, 15.7],
                    [-23.05, 16.8],
                    [22.85, 16.8],
                    [23.95, 15.7],
                    [24.15, -15.6]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [249.15, 246.2], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 72,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "BG",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [249.8, 249.9, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [500, 500, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-27.415, 0],
                    [0, -27.415],
                    [27.415, 0],
                    [0, 27.415]
                  ],
                  "o": [
                    [27.415, 0],
                    [0, 27.415],
                    [-27.415, 0],
                    [0, -27.415]
                  ],
                  "v": [
                    [0, -49.64],
                    [49.64, 0],
                    [0, 49.64],
                    [-49.64, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.839215695858, 0.937254905701, 0.952941179276, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 72,
      "st": 0,
      "ct": 1,
      "bm": 0
    }
  ],
  "markers": []
}
